import React from 'react';
import {Dialog, DialogActions, Button, Fab} from '@material-ui/core'




export default class AlertChestionar extends React.Component {
    constructor(props) {
      super(props);
       this.state = {
      
         }
    }

     componentDidMount(){
          
    }

   
     render() { 
       return (
          <div>
               <Dialog 
                 className="insertDialog"
                style={{padding:10}}
                disableEscapeKeyDown
                 open={this.props.open}
                 onClose={this.props.dialogClose}>
                 <DialogActions >
                 <Fab onClick={this.props.dialogClose} className="chestionare-anuleaza-button">
                            <i className='material-icons textPrimary iconFontSize'>close</i>
                        </Fab>
                 </DialogActions>
                 <h2 style={{padding:10}} className='chestionare-dialog-title'>{this.props.title}</h2>
                 <DialogActions className="chestionare-dialog-bottom-buttons">
                          
                          <Button  variant="contained" onClick={this.props.yesFunction} className='chestionare-main-button'>
                                      {this.props.noButtonDisplay === 1 ? 'OK'    : "DA"}
                          </Button>

                           <Button style={{display:this.props.noButtonDisplay === 1 ? 'none' : 'inline-flex'}} variant="contained" onClick={this.props.dialogClose} className='chestionare-delete-button'>
                                      NU
                          </Button>
                          
                       
                      </DialogActions>
                       
                   
                 </Dialog>
         </div>
        );
       }
}